import React from 'react';
import RenderTextField from "../inputs/renderTextField";
import { Field } from 'redux-form/immutable';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ScoreRecordFormTableValidator from "../validation/forms/scoreRecordFormTable";
import Info from "@material-ui/icons/Info";
import Tooltip from "@material-ui/core/Tooltip";
import InputAdornment from '@material-ui/core/InputAdornment';
import moment from "moment";

const RenderScoresTableRow = ({ fields, meta: { error }, iteratedStore, parseCriterionFromFormTable,
                                personHasScoredNewStoreForCriterion, getStoreScoreForCriterionAverageValue}) => {
  return (
    <TableRow>
      <TableCell scope={'row'}>

        <Tooltip
          disableFocusListener
          title={<ul className={'ul__style_less'}>
            <li>{'Id code: ' + iteratedStore.dwId}</li>
            <li>{'Entersoft code: ' + iteratedStore.enterSoftCode}</li>
            <li>{'Open date: ' + moment(iteratedStore.openDate).format('DD/MM/YYYY HH:mm:ss')}</li>
          </ul>}
        >
          <span>{iteratedStore.name}</span>
        </Tooltip>
      </TableCell>
      {
        fields.map( (criterion, index) => {
          const iteratedCriterion = parseCriterionFromFormTable(fields.get(index));
          let averageScore;
          const scoreOfNewStore = personHasScoredNewStoreForCriterion(iteratedStore.id, iteratedCriterion.id);
          if(iteratedStore.new && scoreOfNewStore){
            return <TableCell key={index}>{`Already Scored: ${scoreOfNewStore}`}</TableCell>
          } else {
            averageScore = getStoreScoreForCriterionAverageValue(iteratedStore.id, iteratedCriterion.id);
          }
          return (
            <TableCell key={index}>
              <Field
                startAdornment={
                  averageScore ? (
                    <InputAdornment position="start">
                      <Tooltip title={`Average score: ${averageScore}`}>
                        <Info />
                      </Tooltip>
                    </InputAdornment>
                  ):null
                }
                validate={ScoreRecordFormTableValidator}
                min={'0'}
                max={10}
                type={'number'}
                name={`${criterion}.scoreValue`}
                component={RenderTextField}
                label={`Criterion #${index + 1}`}
              />
            </TableCell>
          )
        })
      }
    </TableRow>
  )
};

export default RenderScoresTableRow



// WEBPACK FOOTER //
// ./src/components/scoreRecord/renderScoresTableRow.js